export enum PaymentType {
    Credit = 'Credit Card',
    ACH = 'ACH Transfer',
    Manual = 'Cash/Check'
}
